import { useCallback, useEffect } from 'react';
export var useBuilderListener = function (_a) {
    var currentPage = _a.currentPage, timeFromProps = _a.timeFromProps, reportPageLoaded = _a.reportPageLoaded, instance = _a.instance, enable = _a.enable, onNavigateRequest = _a.onNavigateRequest, onRefreshData = _a.onRefreshData;
    useEffect(function () {
        var _a;
        if (!enable) {
            return;
        }
        var loadingTime = new Date().getTime() - timeFromProps;
        var isCover = window.location.href.indexOf('/set') === -1;
        if (isCover) {
            reportPageLoaded(loadingTime);
        }
        (_a = window === null || window === void 0 ? void 0 : window.top) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'pageLoaded',
            currentPage: currentPage || null,
        }, '*');
        window.parent.postMessage({
            type: 'pageLoaded',
            currentPage: currentPage || null,
        }, '*');
        window.parent.parent.postMessage({
            type: 'pageLoaded',
            currentPage: currentPage || null,
        }, '*');
    }, [enable, currentPage]);
    var onMessage = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, data = _b.data;
        if (data.type === 'goToPage') {
            onNavigateRequest(data.data);
        }
        if (data.type === 'refreshData') {
            data.data && onRefreshData(data.data);
        }
    }, [onNavigateRequest, onRefreshData]);
    useEffect(function () {
        if (!enable) {
            return;
        }
        window.addEventListener('message', onMessage);
        return function () {
            window.removeEventListener('message', onMessage);
        };
    }, [enable, onMessage]);
    useEffect(function () {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.top) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'albumsAppLoaded',
            instance: instance,
        }, '*');
    }, [instance]);
};
//# sourceMappingURL=useBuilderListener.js.map